import { tv } from '@change/ds-utils';

const createSizeVariant = (base: string, sizes: Readonly<{ small: string; medium: string; large: string }>) =>
	tv({ base, variants: { size: sizes } });

export const BodyStyles = createSizeVariant('flex flex-col', {
	small: 'gap-[5.62px] px-[5px] pt-[5px]',
	medium: 'gap-2.5 px-2.5 pt-2.5',
	large: 'gap-3 px-3 pt-3',
});

export const PetitionInfoStyles = createSizeVariant(
	'justify-between items-center flex flex-row font-[Arial] font-semibold leading-[140%] tracking-[-1.1%]',
	{ small: 'text-[5px]', medium: 'text-[10px]', large: 'text-[12px]' },
);

export const PetitionTitleStyles = createSizeVariant('line-clamp-3', {
	small: 'w-[53px] h-[22px]',
	medium: 'w-[104px] h-[45px]',
	large: 'w-[125px] h-[54px]',
});

export const MessageStyles = createSizeVariant(
	'tracking-0 whitespace-pre-line font-[Arial] font-normal leading-[140%]',
	{
		small: 'text-[clamp(3.75px,2.4cqw,4.85px)]',
		medium: 'text-[clamp(7.5px,4.5cqw,9.7px)]',
		large: 'text-[clamp(8.5px,5cqw,11px)]',
	},
);

export const PetitionImageStyles = createSizeVariant('relative shrink-0 overflow-hidden', {
	small: 'h-[24.37px] w-[32.5px] rounded-[2px]',
	medium: 'h-[49px] w-[65px] rounded-[3px]',
	large: 'h-[54px] w-[72px] rounded-small',
});

export const PetitionImageOverlayStyles = createSizeVariant(
	'absolute bottom-0 left-0 right-0 top-0 z-10 m-auto h-[28px] w-[34px]',
	{
		small: 'h-[12.64px] w-[15.35px]',
		medium: 'h-[25px] w-[33px]',
		large: 'h-[28px] w-[34px]',
	},
);

export const ExitIconStyles = createSizeVariant('absolute', {
	small: 'bottom-[1.35px] right-[1.35px] h-[6.32px] w-[6.32px]',
	medium: 'bottom-[2.72px] right-[2.71px] h-[12.64px] w-[12.64px]',
	large: 'bottom-[3px] right-[3px] h-[14px] w-[14px]',
});
